import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=0cc6f1e9&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc6f1e9"]])

export default __exports__